<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstApplicationItem"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedApplicationItem"
		dataKey="ApplicationItemID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--ApplicationItemName-->
				<th>
					<p-columnFilter type="text" field="ApplicationItemName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ParentDesc-->
				<th>
					<p-columnFilter type="text" field="ParentDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SUOnlyDesc-->
				<th>
					<p-columnFilter field="SUOnlyDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSUOnlyDesc
								[ngModel]="value"
								[options]="lstSUOnlyDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Order-->
				<th>
					<p-columnFilter type="text" field="Order" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="ApplicationItemName">Name<p-sortIcon field="ApplicationItemName"></p-sortIcon></th>
				<th pSortableColumn="ParentDesc">Parent<p-sortIcon field="ParentDesc"></p-sortIcon></th>
				<th pSortableColumn="SUOnlyDesc">SU Only<p-sortIcon field="SUOnlyDesc"></p-sortIcon></th>
				<th pSortableColumn="Order">ZOrder<p-sortIcon field="Order"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-ApplicationItem>
			<tr [pSelectableRow]="ApplicationItem" (dblclick)="onRowDblClick(ApplicationItem)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ ApplicationItem[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
